module.exports = __webpack_public_path__ + "media/images/trubshaw_logo-debfb9c5.png";